import auth_required from './hooks/auth_required';
import ProfileGeneral from '@/views/settings/general/general.vue';
import ProfileSecurity from '@/views/settings/security/security.vue';
import ProfileDomains from '@/views/settings/domains/domains.vue';
import ProfileTrackingUrls from '@/views/settings/tracking-urls/tracking-urls.vue';
import ProfileUploadConversions from '@/views/settings/upload-conversions/upload-conversions.vue';
import BotFilters from '@/views/settings/bot-filters/bot-filters.vue';
import Subscription from '@/views/settings/subscription/subscription.vue';
import ReferralProgram from '@/views/settings/referral-program/referral-program.vue';

import Integrations from '@/views/settings/integrations/integrations.vue';
import MultiUserAccess from '@/views/settings/multi-user-access/multi-user-access.vue';
import CustomConversions from '@/views/settings/custom-conversions/custom-conversions.vue';
import PlanDescription from '@/views/settings/plan-description/plan-description.vue';

import desktopViewForced from '@/routes/hooks/desktop-view-forced';
import { useStore } from '@/store';

const activateSettingsTabHook = (to: any, from: any, next: Function) => {
  useStore().setSettingsTabRoute(to.fullPath);
  next();
};

export default [
  {
    path: '/app/profile',
    name: 'app.profile',
    beforeEnter: [auth_required, activateSettingsTabHook, desktopViewForced],
    //@ts-ignore
    component: ProfileGeneral,
    meta: {
      menuType: 'settings',
      pageTitle: 'Settings profile general'
    }
  },
  {
    path: '/app/profile/security',
    name: 'app.profile.security',
    beforeEnter: [auth_required, activateSettingsTabHook, desktopViewForced],
    //@ts-ignore
    component: ProfileSecurity,
    meta: {
      menuType: 'settings',
      pageTitle: 'Settings security'
    }
  },
  {
    path: '/app/profile/domains',
    name: 'app.profile.domains',
    beforeEnter: [auth_required, activateSettingsTabHook, desktopViewForced],
    //@ts-ignore
    component: ProfileDomains,
    meta: {
      aclRules: 'profile.domains',
      menuType: 'settings',
      pageTitle: 'Settings domains'
    }
  },
  {
    path: '/app/profile/tracking-links',
    name: 'app.profile.tracking-links',
    beforeEnter: [auth_required, activateSettingsTabHook, desktopViewForced],
    //@ts-ignore
    component: ProfileTrackingUrls,
    meta: {
      menuType: 'settings',
      pageTitle: 'Settings tracking urls'
    }
  },
  {
    path: '/app/profile/upload-conversions',
    name: 'app.profile.upload-conversions',
    beforeEnter: [auth_required, activateSettingsTabHook, desktopViewForced],
    //@ts-ignore
    component: ProfileUploadConversions,
    meta: {
      aclRules: 'profile.upload-conversions',
      menuType: 'settings',
      pageTitle: 'Settings upload conversion'
    }
  },
  {
    path: '/app/profile/bot-filters',
    name: 'app.profile.bot-filters',
    beforeEnter: [auth_required, activateSettingsTabHook, desktopViewForced],
    //@ts-ignore
    component: BotFilters,
    meta: {
      aclRules: 'profile.bot-filters',
      menuType: 'settings',
      pageTitle: 'Settings bot filters'
    }
  },
  {
    path: '/app/profile/subscription',
    name: 'app.profile.subscription',
    beforeEnter: [auth_required, activateSettingsTabHook, desktopViewForced],
    //@ts-ignore
    component: Subscription,
    meta: {
      aclRules: 'profile.subscription',
      menuType: 'settings',
      pageTitle: 'Settings subscription'
    }
  },
  {
    path: '/app/profile/referral-program',
    name: 'app.profile.referral-program',
    beforeEnter: [auth_required, activateSettingsTabHook, desktopViewForced],
    //@ts-ignore
    component: ReferralProgram,
    meta: {
      aclRules: 'profile.referral-program',
      menuType: 'settings',
      pageTitle: 'Settings referral program'
    }
  },
  {
    path: '/app/profile/integrations',
    name: 'app.profile.integrations',
    beforeEnter: [auth_required, activateSettingsTabHook, desktopViewForced],
    //@ts-ignore
    component: Integrations,
    meta: {
      aclRules: 'profile.integrations',
      menuType: 'settings',
      pageTitle: 'Settings integrations'
    }
  },
  {
    path: '/app/profile/multi-user-access',
    name: 'app.profile.multi-user-access',
    beforeEnter: [auth_required, activateSettingsTabHook, desktopViewForced],
    //@ts-ignore
    component: MultiUserAccess,
    meta: {
      aclRules: 'profile.multi-user-access',
      menuType: 'settings',
      pageTitle: 'Settings multi-user access'
    }
  },
  {
    path: '/app/profile/custom-conversions',
    name: 'app.profile.custom-conversions',
    beforeEnter: [auth_required, activateSettingsTabHook, desktopViewForced],
    //@ts-ignore
    component: CustomConversions,
    meta: {
      aclRules: 'profile.custom-conversions',
      menuType: 'settings',
      pageTitle: 'Settings custom conversions'
    }
  },
  {
    path: '/app/profile/plan-description',
    name: 'app.profile.plan-description',
    beforeEnter: [auth_required, activateSettingsTabHook, desktopViewForced],
    component: PlanDescription,
    meta: {
      aclRules: 'profile.plan-description',
      menuType: 'settings',
      pageTitle: 'Plan Details'
    }
  }
];
